export class StockSTatementReq{
    date:any
    plantId?: number | number[];
    constructor(date:any,    plantId?: number | number[]
    ){
        this.date = date
        this.plantId=plantId
    }
}